/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Banner_ChangeInputs */



/**
* | output |
* | --- |
* | "Change" |
*
* @param {Tournament_Banner_ChangeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_banner_change = /** @type {((inputs?: Tournament_Banner_ChangeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Banner_ChangeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica")
	return /** @type {LocalizedString} */ ("Change")
});